import { render, staticRenderFns } from "./Derek.vue?vue&type=template&id=62f1589b"
import script from "./Derek.vue?vue&type=script&lang=js"
export * from "./Derek.vue?vue&type=script&lang=js"
import style0 from "./Derek.vue?vue&type=style&index=0&id=62f1589b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports